'use client';
import LoginTemplate from '@/components/Login/LoginTemplate';
import FirstAccess from '@/views/Login/components/FirstAccess/FirstAccess';
import { useRouter, useSearchParams } from 'next/navigation';

export default function PrimeiroAcesso() {
  const router = useRouter();
  const searchParams = useSearchParams();

  const email = searchParams?.get('email');

  function handleGoBack(email?: string) {
    if (email) {
      router.push(`/entrar?email=${encodeURIComponent(email)}`);
    } else {
      router.push('/entrar');
    }
  }

  return (
    <LoginTemplate>
      <FirstAccess
        onGoBack={handleGoBack}
        defaultFocus={email ? 'password' : 'email'}
        initialValues={{ email: email ?? undefined }}
      />
    </LoginTemplate>
  );
}
